module.exports = __webpack_public_path__ + "static/img/165_TO8_1905_og.4959856.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/165_TO8_1905_og.jpg
// module id = YoK/
// module chunks = 0